import { render, staticRenderFns } from "./langSwitch.vue?vue&type=template&id=2f3e8019"
import script from "./langSwitch.vue?vue&type=script&lang=js"
export * from "./langSwitch.vue?vue&type=script&lang=js"
import style0 from "./langSwitch.vue?vue&type=style&index=0&id=2f3e8019&prod&lang=scss"
import style1 from "./langSwitch.vue?vue&type=style&index=1&id=2f3e8019&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports